/**
 * @file validator-plugin
 * @description 表单项校验插件
 */

import {Validator} from 'vee-validate';

const dict = {
    zhCN: {
        messages: {
            required: () => {
                return '*必填，不能为空';
            },
            max: () => {
                return '超出长度';
            }
        }
    }
};
// 设置提示信息中文方式显示
Validator.localize('zh_CN', dict.zhCN);

export const config = {
    errorBagName: 'errors',
    fieldsBagName: 'fields',
    delay: 100,
    locale: 'zh_CN',
    strict: true,
    enableAutoClasses: true,
    events: 'blur',
    inject: true
};
